/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.wrap table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0 0;
  color: var(--color-emphasis-medium, #525252);
}
.shadow {
  --tw-shadow: 0 0 4px var(--tw-shadow-color, #00000029);
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
.wrap th {
  padding: calc(var(--spacing, 0.25rem) * 2);
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
  --tw-font-weight: var(--font-weight-bold, 700);
  font-weight: var(--font-weight-bold, 700);
}
.wrap td {
  height: calc(var(--spacing, 0.25rem) * 10);
  padding-inline: calc(var(--spacing, 0.25rem) * 2);
  padding-block: calc(var(--spacing, 0.25rem) * 0.5);
  text-overflow: ellipsis;
  font-size: var(--text-sm, 0.875rem);
  line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
}
.wrap thead {
  height: calc(var(--spacing, 0.25rem) * 12);
}
.wrap thead tr {
  --tw-shadow: 0 0 4px var(--tw-shadow-color, #00000029);
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  height: calc(var(--spacing, 0.25rem) * 8);
}
.wrap th, .wrap tfoot td {
  text-align: left;
  vertical-align: middle;
}
.wrap tfoot td {
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
  white-space: nowrap;
}
.wrap .stickyHeaders tfoot, .wrap .stickyHeaders thead {
  position: sticky;
  z-index: 10;
}
.wrap .stickyHeaders tfoot {
  bottom: calc(1px * -1);
}
.wrap .stickyHeaders thead {
  top: calc(1px * -1);
}
.wrap thead th {
  background-color: var(--color-gray-200, #e5e5e5);
}
.wrap tfoot th, .wrap tfoot td {
  background-color: var(--color-gray-100, #f5f5f5);
}
.wrap th:first-child {
  border-left-style: var(--tw-border-style);
  border-left-width: 1px;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.wrap th:last-child {
  border-right-style: var(--tw-border-style);
  border-right-width: 1px;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.wrap tr:not(:last-child) {
  --tw-border-style: solid;
  border-style: solid;
  border-style: var(--tw-border-style);
  border-width: 0px;
  border-bottom-style: var(--tw-border-style);
  border-bottom-width: 1px;
  border-color: var(--color-gray-200, #e5e5e5);
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-font-weight: initial;
      --tw-border-style: solid;
    }
  }
}
